import React, { useEffect, useMemo, useState } from 'react';
import { ColorTag } from '../ColorTag';
import PropTypes from 'prop-types';
import { useFeathers } from '../../../app/util';

const partyDictStatic = {
  'R': {
    text: 'republican',
    textShort: 'rep',
    color: 'red'
  },
  'D': {
    text: 'democrat',
    textShort: 'dem',
    color: 'blue'
  },
  'I': {
    text: 'indepdendent',
    textShort: 'ind',
    color: 'black'
  },
  'N': {
    text: 'nonpartisan',
    textShort: 'np',
    color: 'black'
  },
  'G': {
    text: 'green party',
    textShort: 'green',
    color: 'green'
  },
  'L': {
    text: 'libertarian',
    textShort: 'lib',
    color: 'yellow'
  }
};

const partyDataFromParty = (party) => {
  if (!party?.key) return null;
  return {
    text: party.name || party.key,
    textShort: party.key,
    color: 'grey'
  };
};

const PartyTag = ({ party, style = {}, className = '', onClick, short, preloadedParties }) => {
  const feathers = useFeathers();
  const [loadedParty, setLoadedParty] = useState(null);

  const partyDict = useMemo(() => {
    const preloadedPartyDict = (preloadedParties || []).reduce((acc, partyOption) => {
      const partyData = partyDataFromParty(partyOption);
      if (!partyData) return acc;
      return {
        ...acc,
        [partyOption.key]: partyData,
      };
    }, {});

    return {
      ...preloadedPartyDict,
      ...partyDictStatic,
    };
  }, [preloadedParties]);

  const dataForParty = partyDict[party] || partyDataFromParty(loadedParty);

  useEffect(() => {
    let cancelled = false;
    setLoadedParty(null);

    if (!party || partyDict[party] || !feathers) return;

    const loadParty = async () => {
      try {
        const response = await feathers.getService('parties').find({
          query: {
            key: party,
            $limit: 1,
          },
        });
        const partyResult = Array.isArray(response) ? response[0] : response?.data?.[0];
        if (!cancelled) setLoadedParty(partyResult || null);
      } catch (error) {
        if (!cancelled) setLoadedParty(null);
      }
    };

    loadParty();

    return () => {
      cancelled = true;
    };
  }, [feathers, party, partyDict]);

  if(!dataForParty) return null;

  return (
    <ColorTag style={style} className={className} themeColor={dataForParty.color} onClick={onClick}>
      {short ? party.toUpperCase() : dataForParty.text.toUpperCase()}
    </ColorTag>
  );
}

PartyTag.propTypes = {
  party: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  short: PropTypes.bool,
  preloadedParties: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }))
};

export {PartyTag};
